import { ENUM_ProductType } from '@api-new/mortgageservice';

export const ENUM_ProductTypeMap = new Map([
  [ENUM_ProductType.PRODUCT_TYPE_FIXED, 'Fixed'],
  [ENUM_ProductType.PRODUCT_TYPE_STANDARD, 'Standard'],
  [ENUM_ProductType.PRODUCT_TYPE_STEPPED, 'Stepped'],
  [ENUM_ProductType.PRODUCT_TYPE_DISCOUNT, 'Discount'],
  [ENUM_ProductType.PRODUCT_TYPE_AMDM, 'AMDM'],
  [ENUM_ProductType.PRODUCT_TYPE_BBR, 'BBR'],
  [ENUM_ProductType.PRODUCT_TYPE_LIBOR, 'LIBOR'],
  [ENUM_ProductType.PRODUCT_TYPE_SELF, 'Self'],
  [ENUM_ProductType.PRODUCT_TYPE_STBTL, 'STBTL'],
  [ENUM_ProductType.PRODUCT_TYPE_UNSPECIFIED, 'Unspecified'],
]);
